import { reactive, computed, watch } from 'vue';
import { ACTIONBAR } from '@/enum/enum';
import {useI18n} from 'vue-i18n';

export default {
  name: 'ctmenu',
  components: {},
  props: {
    isShow: {
      type: Boolean,
      required: false,
      default: true,
    },
    list: {
      type: Array,
      required: false,
      default: [
        {
          title: 'Download CSV',
          val: ACTIONBAR.DOWNLOAD,
          disabled: false,
        },
        {
          title: 'Settings',
          val: ACTIONBAR.SETTING,
          disabled: false,
        },
        {
          title: 'View Appointment',
          val: ACTIONBAR.VIEWAPP,
          disabled: false,
        },
        {
          title: 'View History',
          val: ACTIONBAR.VIEWHIS,
          disabled: false,
        },
        {
          title: 'Set Calibration',
          val: ACTIONBAR.SETCAL,
          disabled: true,
        }
      ],
    },
    position: {
      type: Object,

    }
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    //const { isShow ,position } = props;
    const state = reactive({
      showMenu: false,
    })
    const selectContextMenu = (e) => {
      if(!e.disabled){
        emit("selectContextMenu", e);
        state.showMenu = false;
      }
      
    }


    watch(
      () => props.position,
      () => {
        state.showMenu = true
      },
      { deep: true }
    )


    const style = computed(
      () => {
        return {
          left: `${props.position.x}px`,
          top: `${props.position.y}px`,
        };
      }
    )

    const handleFocusOut = ()=>{
      state.showMenu = false
    }

    return {
      state,
      style,
      selectContextMenu,
      handleFocusOut,
      t


    }
  }// end: setup
}

